export default __webpack_public_path__ + "static/media/bl14.4afe5265.png";